// extracted by css-extract-rspack-plugin
export default {"buttons":"Whavb"};